export default {
  // Font family
  family: {
    primary: 'HelveticaNowDisplay',
  },

  // Font weight
  weight: {
    regular: '300',
    xbold: '900',
  },

  // Line-height
  lineHeight: {
    small: '1',
    medium: '1.5',
    large: '2',
  },

  // Font Sizes
  size: {
    xsmall: '0.75rem',
    small: '0.875rem',
    default: '1rem',
    medium: '1.25rem',
    xmedium: '1.5rem',
    large: '1.875rem',
    xlarge: '3rem',
    xxlarge: '3.75rem',
  },
};
